import { gql } from '@apollo/client';

export const GET_AVAILABILITY_INSIGHTS = gql`
  query getAvailabilityInsights($dataScope: DataScope!, $locationId: ID!, $startAt: ISO8601DateTime!, $endAt: ISO8601DateTime!) {
    availabilityInsights(dataScope: $dataScope, locationId: $locationId, startAt: $startAt, endAt: $endAt) {
      availableTime
      scheduledTime
    }
  }
`;
